import { Injectable } from '@angular/core';
import { BaseContentService } from './base-content-service';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import { Observable } from 'rxjs';
import { KPIContentResponse } from './def/kpi-content';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';

@Injectable({
  providedIn: 'root'
})
export class KpiContentService extends BaseContentService<KPIContentResponse> {
  constructor(
    protected http: HttpClient,
    protected configService: AppConfigService
  ) {
    super(http, configService, KpiContentService.staticKpiData);
  }

  get data$(): Observable<KPIContentResponse> {
    if (!this.loaded) {
      return this.getKPIData();
    }

    return of(this.data);
  }

  getKPIData(): Observable<KPIContentResponse> {
    const url = `${this.serviceBaseUrl}kpi`;
    return this.get<KPIContentResponse>(url).pipe(
      map(data => {
        this.data = this.kpiDataMapper(data);
        this.loaded = true;
        return this.data;
      }),
      catchError(this.handleError)
    );
  }

  private kpiDataMapper(data: KPIContentResponse): KPIContentResponse {
    if (!data) return;

    return data;
  }

  private static staticKpiData: KPIContentResponse = {
    pageName: 'kpi',
    tabMenu: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 4,
            image: null,
            icon: ''
          }
        ]
      }
    ],
    tabLabels: [
      {
        heading: '',
        displayItems: [
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 1,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 2,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 3,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 4,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 5,
            image: null,
            icon: ''
          },
          {
            keyText: '',
            description: '',
            apiMappingKey: '',
            navigation: null,
            orderId: 6,
            image: null,
            icon: ''
          }
        ]
      }
    ]
  };
}
